<template>
  <div>
    <v-snackbar v-model="showSnackbar" :timeout="5000" :color="snackbarColor">
      {{ snackbarMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="showSnackbar = false">Cerrar</v-btn>
      </template>
    </v-snackbar>

    <v-row class="ma-0 mb-2 justify-end">
      <v-btn color="primary" rounded small @click="openCreateDialog">
        <v-icon left small>mdi-plus</v-icon>Agregar servicio
      </v-btn>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="services"
      :loading="loadingServices"
      no-data-text="Esta clínica todavía no tiene servicios configurados."
      dense
    >
      <template v-slot:item.origin="{ item }">
        <v-chip x-small :color="item.serviceId ? 'blue lighten-4' : 'grey lighten-2'">
          {{ item.serviceId ? 'Catálogo' : 'Propio' }}
        </v-chip>
      </template>
      <template v-slot:item.pricing="{ item }">
        {{ item.pricing | clpCurrency }}
      </template>
      <template v-slot:item.visible="{ item }">
        <v-switch
          v-if="!item.serviceId"
          :input-value="item.visible"
          hide-details
          dense
          class="mt-0 pt-0"
          @change="toggleVisible(item)"
        ></v-switch>
        <span v-else class="grey--text">—</span>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn icon small @click="openEditDialog(item)">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <v-dialog v-model="showDialog" min-width="600" max-width="900" @keydown.esc="closeDialog">
      <clinic-service-modal
        v-if="showDialog"
        :clinic-id="clinicId"
        :service="selectedService"
        @update-list="onUpdateList"
        @close-dialog="closeDialog"
      ></clinic-service-modal>
    </v-dialog>
  </div>
</template>

<script>
import ClinicsService from '../services/clinics.service';
import ClinicServiceModal from './ClinicServiceModal.vue';
import { utilsMixin } from '../mixins/utilsMixin';

export default {
  name: 'ClinicServicesMaintainer',

  components: { ClinicServiceModal },

  mixins: [utilsMixin],

  props: {
    clinicId: { type: String, required: true }
  },

  data() {
    return {
      services: [],
      loadingServices: false,
      showDialog: false,
      selectedService: null,
      headers: [
        { text: 'Título', value: 'title' },
        { text: 'Origen', value: 'origin' },
        { text: 'Precio', value: 'pricing' },
        { text: 'Visible', value: 'visible' },
        { text: '', value: 'actions', sortable: false, align: 'end' }
      ],
      showSnackbar: false,
      snackbarMessage: '',
      snackbarColor: ''
    };
  },

  watch: {
    clinicId() {
      this.fetchServices();
    }
  },

  mounted() {
    this.fetchServices();
  },

  methods: {
    // Combina services/pricing (variantes de catálogo + propios, sin `visible`) con
    // services/own/manage (solo propios, con `visible`, incluye ocultos) — ningún endpoint
    // individual trae ambas cosas (research.md R4, 014-clinic-onboarding-ui).
    async fetchServices() {
      this.loadingServices = true;
      const [pricingRes, ownRes] = await Promise.all([
        ClinicsService.getServicePricing(this.clinicId),
        ClinicsService.getOwnServicesForManagement(this.clinicId)
      ]);
      this.loadingServices = false;

      if (pricingRes.status !== 'ok' || ownRes.status !== 'ok') {
        this.showErrorSnackbar('No se pudieron cargar los servicios de la clínica.');
        return;
      }

      const catalogVariants = pricingRes.data.filter(service => service.serviceId);
      this.services = [...catalogVariants, ...ownRes.data];
    },

    openCreateDialog() {
      this.selectedService = null;
      this.showDialog = true;
    },

    openEditDialog(service) {
      this.selectedService = service;
      this.showDialog = true;
    },

    closeDialog() {
      this.showDialog = false;
    },

    async onUpdateList() {
      this.closeDialog();
      await this.fetchServices();
    },

    async toggleVisible(service) {
      const res = await ClinicsService.updateOwnService(this.clinicId, service.id, {
        visible: !service.visible
      });
      if (res.status === 'ok') {
        await this.fetchServices();
      } else {
        this.showErrorSnackbar('No se pudo actualizar la visibilidad del servicio.');
      }
    }
  }
};
</script>
